export default {

  TASKS_PARAMS: store => {
    return store.tasksParams;
  }
};
